
import React, { useState } from 'react';

export type searchCotextType = {
    searchTerm: string,
    replacmentString: string,
    changeSearch: (searchTerm: string) => void,
    initialize: () => void,
}

export const SearchContext = React.createContext<searchCotextType>({
    searchTerm: "",
    replacmentString: "##@##",
    changeSearch: (searchTerm: string) => {
        console.log(searchTerm);
    },
    initialize: () => {
        console.log("init search term...");
    }
});

export const SearchInPageProvider = ({children}: {children? : React.ReactNode}) => {
    const [text, setText] = useState<string>("");
    
    const changeSearch = (searchTerm: string) => {
        try{
            setText(()=> searchTerm);
        } catch(e){
            console.error(e);
            setText(()=>"");
            
        }
    }

    const initialize = () => {
        console.log("init search term...");
        setText(()=> "");
    }

    const valueProvider: searchCotextType = {
        searchTerm: text,
        replacmentString: "##@##",
        changeSearch: changeSearch,
        initialize: initialize
    };

    return (
        <SearchContext.Provider value={valueProvider}>
          {children}
        </SearchContext.Provider>
    );

}
